import { Type } from 'class-transformer';
import { IsArray, IsInt, IsString, Min, ValidateNested } from 'class-validator';
import { IngredientResponseDto } from './ingredient-response.dto';

/** One value/count row of the `allergens` facet. */
export class IngredientFacetValueCountDto {
  @IsString()
  value!: string;

  @IsInt()
  @Min(0)
  count!: number;
}

/**
 * Server-side counts for the two UI groups, independent of the current
 * `origin` filter (so switching the origin chip never changes what the chips
 * themselves display) but scoped to the current search text — mirrors how
 * `LotsFacetsDto` treats `q` on the lots list.
 */
export class IngredientsFacetsDto {
  /** `isGlobalCatalogEntry === false` in the tenant-visible union. */
  @IsInt()
  @Min(0)
  mine!: number;

  /** `isGlobalCatalogEntry === true` in the tenant-visible union. */
  @IsInt()
  @Min(0)
  global!: number;

  /** One row per allergen id with at least one matching ingredient in the
   * tenant-visible union, scoped to `q` but never filtered by
   * `allergenIds`/`withoutAllergens` themselves — same self-exclusion rule as
   * `AdminIngredientFacetsDto.allergens`. */
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IngredientFacetValueCountDto)
  allergens!: IngredientFacetValueCountDto[];
}

/** Response of `GET /ingredients`: tenant's own rows union the global
 * catalog, deduped by `normalizedName` (tenant wins) in SQL before
 * `LIMIT`/`OFFSET` ever apply — never a flat array. */
export class IngredientsPageResponseDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IngredientResponseDto)
  items!: IngredientResponseDto[];

  @IsInt()
  @Min(0)
  total!: number;

  @IsInt()
  @Min(1)
  page!: number;

  @IsInt()
  @Min(1)
  pageSize!: number;

  @ValidateNested()
  @Type(() => IngredientsFacetsDto)
  facets!: IngredientsFacetsDto;
}
